import produce from "immer"

import { InferValueTypes } from "client/utils"

import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initBilling: types.Billing = {
    stripePromise: null,

    availablePackages: [],

    billingHistory: [],
    reloadBillingHistory: true,

    cart: [],
    reloadCart: true,
}

const billingReducer = produce((
    draft: types.Billing = initBilling,
    action: ActionTypes = null,
): types.Billing => {
    switch (action.type) {
        case types.BILLING_STRIPE_PROMISE:
            draft.stripePromise = action.stripePromise
            return draft

        case types.BILLING_AVAILABLE_PACKAGES:
            draft.availablePackages = action.packages
            return draft

        case types.BILLING_HISTORY:
            draft.billingHistory = action.history
            return draft

        case types.BILLING_RELOAD_HISTORY:
            draft.reloadBillingHistory = action.value
            return draft

        case types.BILLING_CART:
            draft.cart = action.cart
            return draft

        case types.BILLING_RELOAD_CART:
            draft.reloadCart = action.value
            return draft

        default:
            return draft
    }
})
export default billingReducer
